import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  withCredentials: true, // 필요에 따라 설정
});

// 요청 인터셉터
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // 필요하다면 userId를 querystring이나 body에 자동 추가 가능
  // 단, 모든 API에 넣고 싶은게 맞는지 확인해야 함
  if (userId) {
    if (config.method === 'get') {
      config.params = { ...(config.params || {}), userId };
    } else if (config.method === 'post') {
      config.data = { ...(config.data || {}), userId };
    } else if (config.method === 'put') {
           config.data = { ...(config.data || {}), userId };
    } else if (config.method === 'delete') {
                config.data = { ...(config.data || {}), userId };
    }
  }

  return config;
}, (error) => Promise.reject(error));


// 응답 인터셉터: 401이면 토큰 만료로 간주하고 정리
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      window.dispatchEvent(new Event('storage'));
    }
    return Promise.reject(error);
  }
);

export default instance;